export default "__VITE_PUBLIC_ASSET__81bc741a__"